module.exports = __webpack_public_path__ + "static/mitigate-ff45dec3e8813c16d1452af38d10892d.gif";